import React from 'react';
import './data.css';

const Data = () => {
  return (
    <div className="home__data">
      <h1 className="home__title">Luiz Otávio</h1>
      <h3 className="home__subtitle">Desenvolvedor Front-end</h3>
    </div>
  );
};

export default Data;
